import { getRenderingRef, forceUpdate, getElement } from '@stencil/core';
import { INTERNAL_ROUTER } from './globals.mjs';

const getInternalRouter = () => window[INTERNAL_ROUTER].with(getRenderingRef, forceUpdate, getElement);

export { getInternalRouter };
